import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submit", "checkbox"]

  connect() {
    this.toggle()
  }

  toggle() {
    if (this.hasCheckboxTarget && this.hasSubmitTarget) {
      this.submitTarget.disabled = !this.checkboxTarget.checked
    }
  }
}
